export default __webpack_public_path__ + "static/summer_containers23-fbb8b23f8aafbff17368bf17064e5ea1.webp";